import * as MicrosoftTeams from '@microsoft/teams-js';

export enum ClientType {
  Browser = 'browser',
}

export type AllClientTypes = MicrosoftTeams.HostClientType | ClientType;
